import { fuelProviderName } from './providers';
export function legFuelPriceSelection(leg) {
    var _a, _b, _c;
    switch (leg.fuelUpliftPriceSource) {
        case 'manual':
        case 'offset': {
            return { source: leg.fuelUpliftPriceSource };
        }
        case 'quote': {
            return leg.fuelUpliftProviderName
                ? { source: 'quote', providerName: leg.fuelUpliftProviderName, supplierName: (_a = leg.fuelUpliftSupplierName) !== null && _a !== void 0 ? _a : null }
                : { source: 'manual' };
        }
        default: {
            if (((_b = leg.fuelUpliftRemotePrice) === null || _b === void 0 ? void 0 : _b.state) === 'remote') {
                return { source: 'quote', providerName: fuelProviderName('wfs'), supplierName: null };
            }
            return leg.fuelUpliftPrice == null || ((_c = leg.fuelUpliftRemotePrice) === null || _c === void 0 ? void 0 : _c.state) == null
                ? undefined
                : { source: 'manual' };
        }
    }
}
export function fuelPriceSelectionFields(selection, price) {
    const isQuote = selection.source === 'quote';
    return {
        fuelUpliftPriceSource: selection.source,
        fuelUpliftProviderName: isQuote ? selection.providerName : undefined,
        fuelUpliftSupplierName: isQuote ? selection.supplierName : undefined,
        fuelUpliftRemotePrice: isQuote
            ? { value: price, currency: 'EUR', state: 'manualRemoteAvailable' }
            : { value: undefined, currency: undefined, state: 'manualRemoteNotAvailable' },
    };
}
export function manualFuelPriceFields(priceEur) {
    return priceEur == null
        ? {
            fuelUpliftPrice: undefined,
            fuelUpliftCurrency: 'EUR',
            fuelUpliftPriceSource: undefined,
            fuelUpliftProviderName: undefined,
            fuelUpliftSupplierName: undefined,
            fuelUpliftRemotePrice: undefined,
        }
        : Object.assign({ fuelUpliftPrice: priceEur, fuelUpliftCurrency: 'EUR' }, fuelPriceSelectionFields({ source: 'manual' }, priceEur));
}
export function fuelQuotePriceFields(quote) {
    return Object.assign({ fuelUpliftPrice: quote.priceEurPerLiter, fuelUpliftCurrency: 'EUR' }, fuelPriceSelectionFields(fuelPriceSelectionForQuote(quote), quote.priceEurPerLiter));
}
export function fuelPriceSelectionForQuote(quote) {
    return { source: 'quote', providerName: fuelProviderName(quote.providerId), supplierName: quote.supplierName };
}
export function fuelQuoteForSelection(quotes, selection) {
    if ((selection === null || selection === void 0 ? void 0 : selection.source) !== 'quote') {
        return undefined;
    }
    let match;
    for (const quote of quotes) {
        if (fuelProviderName(quote.providerId) !== selection.providerName) {
            continue;
        }
        if (selection.supplierName == null) {
            if (match == null || quote.priceEurPerLiter < match.priceEurPerLiter) {
                match = quote;
            }
        }
        else if (quote.supplierName === selection.supplierName) {
            return quote;
        }
    }
    return match;
}
export function fuelPriceSelectionLabel(selection) {
    switch (selection.source) {
        case 'manual': {
            return 'Manual';
        }
        case 'offset': {
            return 'Offset estimate';
        }
        case 'quote': {
            return selection.supplierName == null
                ? selection.providerName
                : `${selection.providerName} · ${selection.supplierName}`;
        }
    }
}
export function sameFuelPriceSelection(a, b) {
    if (a == null || b == null) {
        return a === b;
    }
    if (a.source === 'quote' && b.source === 'quote') {
        return a.providerName === b.providerName && a.supplierName === b.supplierName;
    }
    return a.source === b.source;
}
export function legFuelPriceDisplay(leg) {
    var _a;
    const selection = legFuelPriceSelection(leg);
    return {
        price: leg.fuelUpliftPrice == null
            ? null
            : `${leg.fuelUpliftPrice.toFixed(2)} ${(_a = leg.fuelUpliftCurrency) !== null && _a !== void 0 ? _a : 'EUR'}/l`,
        source: selection == null ? null : fuelPriceSelectionLabel(selection),
    };
}
export function fuelSupplierSnapshotLabel(snapshot) {
    return fuelPriceSelectionLabel({
        source: 'quote',
        providerName: snapshot.provider,
        supplierName: snapshot.supplier,
    });
}
export function legFuelSupplierForSnapshot(leg) {
    const selection = legFuelPriceSelection(leg);
    return (selection === null || selection === void 0 ? void 0 : selection.source) === 'quote'
        ? { provider: selection.providerName, supplier: selection.supplierName }
        : null;
}
//# sourceMappingURL=legSelection.js.map